import { UILabComponent } from '@modules/uilab/UILabPageContainer';

import styles from './VerticalList.module.scss';
import { Item } from './Item';

interface VerticalListProps {
    data: UILabComponent[];
}

export function VerticalList({ data }: VerticalListProps) {
    return (
        <div className={styles.root}>
            {data &&
                data.map(({ id, title }) => (
                    <Item
                        key={id}
                        url={id}
                        title={title}
                    />
                ))}
        </div>
    );
}
